/* global React, ReactDOM */

import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { fetchData } from './actions';

const Player = (props) => {
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [playerData, setPlayerData] = useState(null);
  const [targetId, setTargetId] = useState(null);

  const reloadClip = () => {
    if (props.playFrom === playerData.playFrom && props.playTo === playerData.playTo) {
      return;
    }
    playerData.playFrom = props.playFrom;
    playerData.playTo = props.playTo;
    Player.embed({ targetId, ...playerData });
  };

  if (props.clipReload) {
    reloadClip();
  }

  const pause = () => {
    const kdp = document.getElementById(targetId);
    if (kdp) {
      kdp.sendNotification('doPause');
    }
  };

  useEffect(() => {
    if (playerData && scriptLoaded) {
      if (props.onEmbedCallback) {
        if (props.needsDuration) {
          props.onEmbedCallback(playerData.mediaDuration);
        } else {
          props.onEmbedCallback();
        }
      }
      Player.embed({ targetId, ...playerData });
      if (props.pauseOnOutsideClick) {
        document.addEventListener('click', pause);
      }
    } else {
      fetchData(props.url).then((response) => {
        setPlayerData(response);
        const index = document.querySelectorAll('.media-player-container').length - 1;
        setTargetId(`media-player-container-${response.entryId}-${index}`);
        const src = response.scriptSource;
        let script = document.querySelector(`script[src="${src}"]`);
        if (!script) {
          script = document.createElement('script');
          script.src = src;
          script.async = true;
          document.head.appendChild(script);
          script.addEventListener('load', () => setScriptLoaded(true));
        } else {
          setScriptLoaded(true);
        }
      });
    }

    return () => {
      document.removeEventListener('click', pause);
    };
  }, [scriptLoaded]);

  if (scriptLoaded && playerData) {
    // The unmount on RRP is not working without a parent element
    return (
      <span>
        {props.withAddToFolderBtn ? (
          <div className="panel-container">
            <div className="react-notifications-root" />
            <div className="panel-heading clearfix">
              <div
                id={`add-to-folder-button-${props.id}`}
                className="add-to-folder-btn-container"
              ></div>
            </div>
          </div>
        ) : null}
        <div id={targetId} className="media-player-container"></div>
        {props.fromPlayer && <div id="transcript-player-plugin"></div>}
        <div id="video-clipping-tool"></div>
      </span>
    );
  }
  return (
    <div className="media-player-spinner text-center">
      <i className="fa-solid fa-arrows-rotate fa-spin fa-3x" />
    </div>
  );
};

Player.embed = (params) => {
  // eslint-disable-next-line no-undef
  kWidget.embed({
    targetId: params.targetId, // The embed will be loaded into the containing element
    wid: `_${params.partnerId}`, // An internal identifier, comprised of an "_" and the partner id
    uiconf_id: params.uiConfId, // The player identifier
    entry_id: params.entryId, // The video we're loading by default
    flashvars: {
      autoPlay: false,
      sideBarContainer: { plugin: 'true', position: 'left', clickToClose: 'true' },
      chapters: { plugin: 'true', layout: 'vertical', thumbnailRotator: 'false' },
      dualScreen: { plugin: 'true' },
      hotspots: { plugin: true },
      quiz: { plugin: true },
      ks: params.ks,
      mediaProxy: { mediaPlayFrom: params.playFrom, mediaPlayTo: params.playTo }
    }
  });
};

Player.render = (root, props) => {
  ReactDOM.createRoot(root).render(
    React.createElement(Player, props)
  );
};

Player.propTypes = {
  onEmbedCallback: PropTypes.any,
  pauseOnOutsideClick: PropTypes.bool,
  url: PropTypes.string,
  fromPlayer: PropTypes.bool,
  needsDuration: PropTypes.bool,
  clipReload: PropTypes.bool,
  playFrom: PropTypes.number,
  playTo: PropTypes.number,
  withAddToFolderBtn: PropTypes.bool,
  id: PropTypes.number
};

export default Player;
